import type { ThemeOptions } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import deepmerge from "@mui/utils/deepmerge";
import { BaseThemeObject } from "./BaseThemeObject";

const FixNationRestorationThemeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: "#00276B",
    },
    secondary: {
      main: "#E03020",
    },
    background: {
      default: "#E6EBF0",
      paper: "#FAFAFA",
    },
  },
};

export const FixNationRestorationTheme = createTheme(
  deepmerge(BaseThemeObject, FixNationRestorationThemeOptions)
);
